import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'hooks/useAuth';
import { useClient } from 'hooks/useClient';

/** Month-to-date website sessions, the billed unit. There is no money here: the plans are flat. */
export type BillingUsage = { sessions: number };

/**
 * Month-to-date website sessions, from `GET /api/billing/usage`. For an agency
 * this is already the total across every client billed to it (queried by
 * payerCompanyId server-side); the per-client breakdown is `useClientUsage`. The
 * plan's own allowance, in its own window, is `useBillingAllowance`.
 */
export const useBillingUsage = () => {
  const apiClient = useClient();
  const { user } = useAuth();

  const {
    data: usage,
    isLoading,
    isError,
    refetch,
  } = useQuery<BillingUsage>({
    queryKey: ['BILLING_USAGE'],
    enabled: !!user,
    queryFn: () => apiClient.get('/billing/usage'),
  });

  return { usage, isLoading, isError, refetch };
};
